const RepairFileGuaranteeConstant = {
  SERIAL_NUMBER: 'SERIAL_NUMBER',
  COMMERCIAL: 'COMMERCIAL',
  EXTENSION: 'EXTENSION',
  FORCE_GUARANTEE: 'FORCE_GUARANTEE',
  NOT_GUARANTEE: 'NOT_GUARANTEE'
}

export default RepairFileGuaranteeConstant;
